<div
  class="mx-auto w-full max-w-lg rounded-md border bg-white p-4 shadow"
  *ngIf="imageChangedEvent"
>
  <p class="text-center">The cropped image will be {{ imageDimension }}</p>
  @if (isBrowser) {
  <image-cropper
    class="imagecropper"
    [resizeToWidth]="cropWidth"
    [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="maintainAspectRatio"
    [aspectRatio]="aspectRatio"
    outputType="base64"
    format="png"
    (imageCropped)="imageCropped($event)"
  ></image-cropper>
  }

  <div class="mt-4 flex justify-between">
    <button class="rounded bg-gray-300 px-4 py-1" (click)="cancel()">
      Cancel
    </button>
    <button
      class="rounded bg-blue-500 px-4 py-1 text-white"
      (click)="confirmCrop()"
    >
      Crop
    </button>
  </div>
</div>
